import { Map } from 'immutable';
import { EntityTypesEnum } from '../../../app.enum';
import { IChangeField } from '../../../utils/helpers/model.helper';
import {
  entityKeys,
  entityModelFactory,
  generateContent,
} from '../../entity-data/entity.model';
import { File } from '../../files/file.model';

export const CONTENT_SCHEMA = Object.freeze({
  DESCRIPTION: '',
  TOTAL: 0,
  MERCHANT: '',
  CATEGORY: '',
  TAX: 0,
  DATE: null, // i2g-timezoneless-date (yyyy-mm-dd)
  TIP: 0,
  FILE: File,
  LOCALE: '',
  CURRENCY_CODE: '',
});
const KEYS = entityKeys({}, CONTENT_SCHEMA);
export const CONTENT_KEYS = generateContent(CONTENT_SCHEMA).KEYS;
const contentChanges = (contentProps: Map<string, any>): IChangeField[] => {
  const file = contentProps.get(CONTENT_KEYS.FILE);

  return [
    {
      key: CONTENT_KEYS.FILE,
      value: file ? new File(file) : null,
    },
  ];
};

export class Expense extends entityModelFactory(
  {},
  null,
  CONTENT_SCHEMA,
  contentChanges
) {
  static ENTITY_TYPE: EntityTypesEnum = EntityTypesEnum.expense;
  static KEYS: any = KEYS;
  static CONTENT_KEYS: any = CONTENT_KEYS;

  get ENTITY_TYPE(): string {
    return Expense.ENTITY_TYPE;
  }

  get description(): string {
    return this.getFieldInContent(CONTENT_KEYS.DESCRIPTION);
  }

  get total(): number {
    return this.getFieldInContent(CONTENT_KEYS.TOTAL);
  }

  get fileId(): string {
    const file = this.file;

    return file ? file.id : null;
  }

  get merchant(): string {
    return this.getFieldInContent(CONTENT_KEYS.MERCHANT);
  }

  get category(): string {
    return this.getFieldInContent(CONTENT_KEYS.CATEGORY);
  }

  get tax(): number {
    return this.getFieldInContent(CONTENT_KEYS.TAX);
  }

  get date(): string {
    return this.getFieldInContent(CONTENT_KEYS.DATE);
  }

  get tip(): number {
    return this.getFieldInContent(CONTENT_KEYS.TIP);
  }

  get file(): File {
    return this.getFieldInContent(CONTENT_KEYS.FILE);
  }

  get currencyCode(): string {
    return this.getFieldInContent(CONTENT_KEYS.CURRENCY_CODE);
  }

  get locale(): string {
    return this.getFieldInContent(CONTENT_KEYS.LOCALE);
  }
}
